export default "__VITE_ASSET__9XZEvh4l__"